<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type half_int">
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'"> </autocomplete>
				</span>
			</div>
			<div class="left_option" style="padding-top:5px;">
				<span class="int_type_no_border mgr_5">
					<ItemClassSelectMulti v-model.trim="item_classes_string" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big3_tbl">
				<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
					<thead>
						<tr>
							<th style="text-align:center;width:3%;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
							<th style="text-align:center;width:4%;">Designated</th>
							<th style="text-align:center;width:15%;">{{ headers.class }} Code</th>
							<th style="text-align:center;width:15%;">WH Code</th>
							<th style="text-align:center;">{{ headers.class }} Name</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="item in itemClasses" v-bind:key="item.code" v-bind:class="{ on: item.selected }" @click="selectRow(item)">
							<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							<td class="al_center">
								<span v-if="item.designated"><font color="red">&#10004;</font></span>
							</td>
							<td>{{ item.code }}</td>
							<td>{{ item.wh_code }}</td>
							<td class="truncate">
								<span :title="item.name">{{ item.name }}</span>
							</td>
						</tr>
					</tbody>
				</table>

				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

				<div class="view_bottom_bt">
					<a v-if="modifiable" href="javascript:;" class="search_bt mgr_15" @click="register()">Register</a>
					<a v-if="modifiable" href="javascript:;" class="search_bt" @click="unregister()">Unregister</a>
				</div>
			</div>

			<div class="right_small3_tbl" style="height:749px;">
				<div>
					<h4 class="inner_h5">Designated Item {{ headers.class }} List</h4>
					<div class="fixed-table-container" style="height:670px;">
						<!-- <div class="table-wrapper" style="height:410px;"> -->
						<div class="table-wrapper">
							<table id="item_list" class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:2%;">
											<div class="th-text"><input type="checkbox" @change="selectAllDesignated()" v-model="allDesignatedSelected" /></div>
										</th>
										<th style="text-align:center;width:15%;">
											<div class="th-text">{{ headers.class }} Code</div>
										</th>
										<th style="text-align:center;width:15%;"><div class="th-text">WH Code</div></th>
										<th style="text-align:center;">
											<div class="th-text">{{ headers.class }} Name</div>
										</th>
									</tr>
								</thead>

								<tbody>
									<!-- <tr v-for="item in items" v-bind:key="item.item_id" v-bind:class="{ on: item.item_id == selectedItem.item_id }" @click="openModal('ItemDetail', item)"> -->
									<tr v-for="item in designatedItemClasses" v-bind:key="item.item_id" v-bind:class="{ on: item.selected }" @click="selectRow(item)">
										<td class="al_center"><input type="checkbox" id="active_yn" v-model="item.selected" /></td>
										<td>{{ item.code }}</td>
										<td>{{ item.wh_code }}</td>
										<td class="truncate">
											<span :title="item.name">{{ item.name }}</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div style="text-align:right;padding-top:5px;padding-right:15px;">Total Count : {{ designatedItemClasses.length | commaSeparated }}</div>
						<div class="view_bottom_bt">
							<a v-if="modifiable" href="javascript:;" class="search_bt mgr_15" @click="unregister()">Unregister</a>
							<!-- <a v-if="modifiable" href="javascript:;" class="search_bt" @click="save()">Save</a> -->
							<!-- <a v-if="modifiable" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()" class="delete_button">Delete</a> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectItemClassList, apiUpdateDesignatedItemClasses } from '@/api/item/class.js';
import _ from 'lodash';
import Paging from '@/components/common/Paging';
// import CodeSelect from '@/components/common/CodeSelect';
// import Modal from '@/components/common/Modal';
// import ItemDetail from '@/components/common/ItemDetail';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import '@/assets/css/table_box.css';

export default {
	data: function() {
		return {
			item_classes_string: '',
			item_classes: [],

			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			keyword: '',

			itemClasses: [],

			designatedItemClasses: [],

			allSelected: false,
			allDesignatedSelected: false,
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		Paging,
		ItemClassSelectMulti,
	},
	methods: {
		async register() {
			var selectedClasses = this.itemClasses.filter(i => i.selected);
			if (selectedClasses.length == 0) {
				this.$toast.error('Nothing Selected');
				return false;
			}

			const { data } = await apiUpdateDesignatedItemClasses({
				item_class_list: selectedClasses,
				designated: 1,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');
				var vm = this;
				selectedClasses.forEach(sc => {
					if (vm.designatedItemClasses.filter(bc => bc.code == sc.code).length == 0) {
						sc.designated = true;
						sc.selected = false;
						vm.designatedItemClasses.push(_.cloneDeep(sc));
					}
					sc.selected = false;
				});
			} else {
				this.$toast.error(data.msg);
			}
		},
		async unregister() {
			if (this.designatedItemClasses.filter(i => i.selected).length == 0) {
				this.$toast.error('Nothing Selected');
				return false;
			}

			const { data } = await apiUpdateDesignatedItemClasses({
				item_class_list: this.designatedItemClasses.filter(i => i.selected),
				designated: 0,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');
				var vm = this;
				for (var i = this.designatedItemClasses.length - 1; i >= 0; i--) {
					if (this.designatedItemClasses[i].selected) {
						vm.itemClasses
							.filter(ic => ic.code == this.designatedItemClasses[i].code)
							.forEach(ic => {
								ic.designated = false;
							});
						this.designatedItemClasses.splice(i, 1);
					}
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		async unregisterFromList() {
			var selectedClasses = this.itemClasses.filter(ic => ic.selected && ic.designated);
			if (selectedClasses.length == 0) {
				this.$toast.error('No Valid Item(s) Selected');
				return false;
			}

			const { data } = await apiUpdateDesignatedItemClasses({
				item_class_list: selectedClasses,
				designated: 0,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');
				var vm = this;
				selectedClasses.forEach(ic => {
					ic.designated = false;
					//ic.selected = false;
					for (var i = vm.designatedItemClasses.length - 1; i >= 0; i--) {
						if (vm.designatedItemClasses[i].code == ic.code) {
							vm.designatedItemClasses.splice(i, 1);
						}
					}
				});
				this.itemClasses
					.filter(ic => ic.selected)
					.forEach(ic => {
						ic.selected = false;
					});
			} else {
				this.$toast.error(data.msg);
			}
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += ', ' + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
			//this.itemClass = c.selectedObject.code;
			//this.search();

			//console.log(c.selectedObject.code);
		},

		search() {
			if (this.item_classes_string) this.item_classes = this.item_classes_string.split(',');
			else this.item_classes = [];
			//console.log(this.item_classes);

			this.selectItemClasses();
		},
		reset() {
			this.page_no = 1;
			this.keyword = '';

			this.item_classes_string = '';
			this.item_classes = [];
			this.allSelected = false;
		},
		async selectItemClasses(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			this.itemClasses = [];
			this.allSelected = false;

			const { data } = await apiSelectItemClassList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				active_yn: 'A',
				closed_yn: 'A',
				item_classes: this.item_classes,
			});

			//console.log(data);
			this.itemClasses = data.itemClassList;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
			//this.$router.replace('/item/item_class?active_yn=' + this.active_yn + 'closed_yn=' + this.closed_yn + '&page_no=' + this.page_no).catch(err => err);

			//if (this.itemClasses.length > 0) this.selectRow(this.itemClasses[0]);
		},

		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectItemClasses(pageNo);
		},
		selectRow(item) {
			if (item.selected) item.selected = false;
			else item.selected = true;

			//console.log(item.checked);
			this.$forceUpdate();
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.itemClasses.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},

		selectAllDesignated() {
			var vm = this;
			this.designatedItemClasses.forEach(function(item) {
				item.selected = vm.allDesignatedSelected;
			});
		},

		async index() {
			const { data } = await apiSelectItemClassList({
				paging_yn: 'N',

				active_yn: 'A',
				closed_yn: 'A',
				designated: true,
			});

			//console.log(data);
			this.designatedItemClasses = data.itemClassList;
		},
	},
	created() {
		//this.$store.sideIndex = 1;
		this.$store.commit('setSideIndex', 1);
		//this.$store.selectedMenu = 'nav_li_1';
		this.$store.commit('setSelectedMenu', 'nav_li_item_desigation');
		this.$store.commit('setSubTitle', 'Item -> Designation');

		this.index();
		this.selectItemClasses();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
